"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontBes = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
const echain_product_models_1 = require("@igus/echain-product-models");
class MontBes extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'MontBes';
    }
    static fromScratch() {
        return new MontBes({
            ArticleType: echain_product_models_1.ArticleType.montBes,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const montBes = MontBes.fromScratch();
        montBes.fromJson(json, cloneStrategy);
        return montBes;
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'MontBes.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const montBes = MontBes.fromJson(args, cloneStrategy);
        montBes.artNrExists = true;
        return montBes;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'MontBes.fromInventedArtNrArgs: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const montBes = MontBes.fromJson(args, cloneStrategy);
        montBes.artNrExists = false;
        return montBes;
    }
    static fromModel(model) {
        const montBes = MontBes.fromScratch();
        Object.assign(montBes.model, model);
        Object.assign(model, montBes.model);
        montBes.model = model;
        return montBes;
    }
    clone() {
        return this._clone(MontBes.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
}
exports.MontBes = MontBes;
//# sourceMappingURL=MontBes.js.map